import React from 'react';
import '../styles/components.css';

const PlayerList = ({
    players,
    roundScores,
    promptGiver,
    guesses,
    status,
    isPromptRevealed,
    currentPrompt,
    userId,
    isExpanded,
    onToggleExpand,
    disconnectedPlayerIds = []
}) => {
    // Convert players object to array if it's not already an array
    const playersList = Array.isArray(players)
        ? players
        : Object.entries(players || {}).map(([id, player]) => ({
            id,
            ...player
        }));

    // Convert guesses object to array if it's not already an array
    const guessesList = Array.isArray(guesses)
        ? guesses
        : Object.values(guesses || {});

    // Count active players
    const activePlayerCount = playersList.filter(player => player.active).length;

    return (
        <div
            className={`side-panel-section players-section ${!isExpanded ? 'collapsed' : ''}`}
        >
            <div className="players-header" onClick={onToggleExpand}>
                <div className="section-title-container">
                    <span className="section-title">{activePlayerCount} Players</span>
                    {(status === 'playing' || (status === 'roundEnd' && !isPromptRevealed)) && (
                        <span className="text-secondary">
                            {guessesList.length}/{activePlayerCount - 1} Guessed
                        </span>
                    )}
                </div>
                <span className="toggle-icon">▼</span>
                {(status === 'playing' || (status === 'roundEnd' && !isPromptRevealed)) && (
                    <div className="progress-container">
                        <div className="progress-bar">
                            <div
                                className="progress-fill success"
                                style={{
                                    width: `${(guessesList.length / (activePlayerCount - 1)) * 100}%`
                                }}
                            />
                        </div>
                    </div>
                )}
            </div>
            <div className="players-list">
                {playersList.map(player => {
                    const isPromptGiverPlayer = player.id === promptGiver?.id;
                    const playerGuess = guessesList.find(g => g.playerId === player.id);
                    const hasGuessed = Boolean(playerGuess);
                    const isCurrentPlayer = player.id === userId;
                    const isDisconnected = disconnectedPlayerIds.includes(player.id);
                    const isInactive = !player.active;

                    return (
                        <div key={player.id}
                            className={`player-tag ${isPromptGiverPlayer ? 'is-prompt-giver' : ''} 
                                ${isDisconnected ? 'is-disconnected' : ''} 
                                ${isInactive ? 'is-inactive' : ''}`}
                        >
                            <div className="player-info">
                                <div className="player-name-container">
                                    <div className="name-section">
                                        <span className="role-badge">{isPromptGiverPlayer ? '🎨' : ' '}</span>
                                        <span className="player-name">
                                            {player.name}
                                            {isCurrentPlayer && <span className="current-player-indicator"> (You)</span>}
                                        </span>
                                    </div>
                                    {isInactive ? (
                                        <span className="status-text inactive">
                                            disconnected
                                        </span>
                                    ) : isDisconnected ? (
                                        <span className="status-text disconnected">
                                            disconnected
                                        </span>
                                    ) : status === 'waiting' && isPromptGiverPlayer ? (
                                        <span className="status-text">
                                            crafting...
                                        </span>
                                    ) : (status === 'playing' || (status === 'roundEnd' && !isPromptRevealed)) && !isPromptGiverPlayer && (
                                        <span className={`status-text ${hasGuessed ? 'submitted' : ''}`}>
                                            {hasGuessed ? '✅ Ready' : '🤔 Thinking'}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default PlayerList; 